
/* eslint-disable */
import React from "react";
import { useState, useEffect } from "react";
import SideBar from "../../../SideBar";
import axios from "axios";

import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import { FaRegEdit, FaRegTrashAlt, FaArrowLeft } from "react-icons/fa";
import apiInstance from "../../../../../utils/api";
function Unit() {
    const scroll = {
        height: "550px",
        overflowY: "scroll",
    };

    const [medicineLists, setMedicineLists] = useState("");
    const [unitLists, setUnitLists] = useState([]);
    const [code, setCode] = useState("");
    const [name, setName] = useState("");
    const [currentQuantity, setCurrentQuantity] = useState("");
    const [reorder, setReorder] = useState("");
    const [fromUnit, setFromUnit] = useState("");
    const [toUnit, setToUnit] = useState("");
    const [purchasePrice, setPurchasePrice] = useState("");
    const [purposeType, setPurposeType] = useState("");
    const [totalUnit, setTotalUnit] = useState("");
    const [showUpdate, setShowUpdate] = useState(false);
    const [Id, setId] = useState("");
    const [supplierList, setSupplierList] = useState([])
    const [supplier, setSupplier] = useState('')
    const [description, setDescription] = useState("");
    const [upCode, setUpCode] = useState("");
    const [upName, setUpName] = useState("");
    const [upDesc, setUpDesc] = useState("");
    const [upCurQTY, setUpCurQTY] = useState("");
    const [upReOrder, setUpReOrder] = useState("");
    const [upFrom, setUpFrom] = useState("");
    const [upTo, setUpTo] = useState("");
    const [upTotal, setUpTotal] = useState("");
    const [upPur, setUpPur] = useState("");
    const [upSell, setUpSell] = useState("");
    const [type, setType] = useState("");
    const [device, setDevice] = useState('')
    const [unit, setUnit] = useState('')
    const [expDate, setExpDate] = useState("")
    // const [medicineListName, setMedicineListname] = useState('');
    const reagentId = useLocation().pathname.split("/")[2];

    const handleDelete = (event) => {
        console.log(event, "delete");
        apiInstance
            .delete("reagent-item/" + event)
            .then((response) => {
                Swal.fire({
                    title: "Success",
                    text: "Successfully Deleted!",
                    icon: "success",
                    confirmButtonText: "OK",
                });
                const result = unitLists.filter((item) => item._id !== event);
                setUnitLists(result);
            })
            .catch((error) => {
                Swal.fire({
                    title: "Error",
                    text: error.response.data.message,
                    icon: "error",
                    confirmButtonText: "CANCEL",
                });
            });
    };

    const submit = (id) => {
        confirmAlert({
            title: "Confirm to submit",
            message: "Are you sure to do this.",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => handleDelete(id),
                },
                {
                    label: "No",
                },
            ],
        });
    };

    const handleUpdate = (event) => {
        console.log(event, "event");
        const getMedUnitUpdate = async () => {
            try {
                const res = await apiInstance.get("reagent-item/" + event);

                console.log(res.data.data[0]);
                setUpCode(res.data.data[0].code);
                console.log(res.data.data[0].code, "code");

                setUpName(res.data.data[0].itemName);
                setUpCurQTY(res.data.data[0].currentQuantity);
                setUpReOrder(res.data.data[0].reOrderQuantity);
                setUpFrom(res.data.data[0].fromUnit);
                setUpTo(res.data.data[0].toUnit);
                setUpTotal(res.data.data[0].totalUnit);
                setUpPur(res.data.data[0].purchasePrice);
                setUpSell(res.data.data[0].sellingPrice);
                setUpDesc(res.data.data[0].description);
                setType(res.data.data[0].itemType);
                setPurposeType(res.data.data[0].purposeType)
                setSupplier(res.data.data[0]?.relatedSupplier)
                setDevice(res.data.data[0]?.device)
                setUnit(res.data.data[0]?.unit)
                setExpDate(res.data.data[0]?.expDate)

            } catch (err) { }
        };
        getMedUnitUpdate();
        setShowUpdate(true);
        setId(event);
    };

    const UnitUpdate = () => {
        const data = {
            id: Id,
            name: reagentId,
            code: upCode,
            itemName: upName,
            currentQuantity: upCurQTY,
            reOrderQuantity: upReOrder,
            purchasePrice: upPur,
            // sellingPrice: upSell,
            fromUnit: upFrom,
            toUnit: upTo,
            totalUnit: upTotal,
            purposeType: purposeType,
            itemType: type,
            description: upDesc,
            relatedSupplier: !supplier._id ? supplier : supplier._id,
            device: device,
            unit: unit,
            expDate: expDate,
        };

        const config = {
            headers: { "Content-Type": "application/json" },
        };
        apiInstance.put("reagent-item", data, config).then(function (response) {
            Swal.fire({
                title: "Successful!",
                text: "You Updated Data!",
                icon: "success",
                showConfirmButton: false,
                timer: 2000
            });
            window.location.reload();

            // return response.data.data

            // setUnitLists(
            //     unitLists.map(category => {
            //         if (category._id === response.data.data._id) {
            //             return response.data.data
            //         } else {
            //             return category
            //         }
            //     })
            // )
        });
        // .catch(function (err) {
        //   Swal.fire({
        //     title: 'Something Wrong!',
        //     text: 'Try again, Please.',
        //     icon: 'warning',
        //     // showCancelButton: true,

        //     cancelButtonText: 'Close'
        //   })
        // })
        // document.getElementById('desc').value = ''
        setName('')
        // document.getElementById('code').value = ''
    };

    const handleUpdateUnitCalculation = (event) => {
        console.log(upCurQTY);
        console.log(event);

        if (upCurQTY) {
            let multi = upCurQTY * event;
            let ans = multi / upFrom;

            setUpTotal(ans.toFixed(2));
        }

        setUpTo(event);
    };

    const handleUnitCalculation = (event) => {
        console.log(currentQuantity);
        console.log(event);

        if (currentQuantity) {
            let multi = currentQuantity * event;
            let ans = multi / fromUnit;

            setTotalUnit(ans.toFixed(2));
        }

        setToUnit(event);
    };

    const UnitCreate = () => {
        const data = {
            id: Id,
            name: reagentId,
            code: code,
            itemName: name,
            currentQuantity: currentQuantity,
            reOrderQuantity: reorder,
            purchasePrice: purchasePrice ? purchasePrice : 0,
            relatedSupplier: supplier,
            device: device,
            unit: unit,
            fromUnit: fromUnit,
            toUnit: toUnit,
            totalUnit: totalUnit,
            purposeType: purposeType,
            expDate: expDate,
            description: description,

        };

        // // console.log(medicineListId);
        // alert(JSON.stringify(data))
        // console.log(data);
        const config = {
            headers: { "Content-Type": "application/json" },
        };
        apiInstance
            .post("reagent-item", data, config)
            .then(function (response) {
                Swal.fire({
                    title: "Successful!",
                    text: "You Created Data!",
                    icon: "success",

                    showConfirmButton: false,
                    timer: 2000
                });
                window.location.reload();
                // setName('')
                // setCode('')
                // setUnitLists(
                //     unitLists.map(category => {
                //         if (category._id === response.data.data._id) {
                //             return response.data.data
                //         } else {
                //             return category
                //         }
                //     })
                // )
            })
            .catch(function (err) {
                Swal.fire({
                    title: "Something Wrong!",
                    text: "Try again, Please.",
                    icon: "warning",
                    // showCancelButton: true,

                    cancelButtonText: "Close",
                });
            });
        // document.getElementById("description").value = "";
        // document.getElementById("name").value = "";
        // document.getElementById("code").value = "";
        // document.getElementById("cur_qty").value = "";
        // document.getElementById("reorder").value = "";
        // document.getElementById("purchase").value = "";
        // document.getElementById("from").value = "";
        // document.getElementById("to").value = "";
        // document.getElementById("sellprice").value = "";
        // document.getElementById("total").value = "";

        //      props.setOpen(false);
    };
    useEffect(() => {
        const getUnitLists = async () => {
            try {
                const res = await apiInstance.get("reagent-items/" + reagentId);

                // setUnitLists(res.data.list.filter((el) => el.name._id == reagentId))
                setUnitLists(res.data.data);
                console.log(res.data.data, 'list')
            } catch (err) { }
        };

        const getReagentLists = async () => {
            try {
                const res = await apiInstance.get("reagent-list/" + reagentId);
                let setMedicineListname = res.data.data?.name;
                setMedicineLists(setMedicineListname);
            } catch (err) {
                alert(err.message);
            }
        };

        const getSupplierLists = async () => {
            try {
                const res = await apiInstance.get("suppliers");

                setSupplierList(res.data.data);
            } catch (err) {
                alert(err.message);
            }
        };
        getSupplierLists();
        getReagentLists()
        getUnitLists();
    }, []);
    return (
        <div classNameName='App'>
            {/* <!-- end preloader --> */}
            {/* @include('sweet::alert') */}

            <div className='wrapper'>
                {/* <!-- Navbar --> */}
                {/* <HeaderName /> */}

                {/* <!-- /.navbar --> */}

                {/* <!-- Main Sidebar Container --> */}
                <SideBar />

                {/* <!-- Content Wrapper. Contains page content --> */}

                <div className='content-wrapper'>
                    {/* <!-- Content Header (Page header) --> */}
                    <div className='content-header'>
                        <div className='container-fluid'>
                            <div className='row mb-2'>
                                <div className='col-sm-12'>
                                    <ol className='breadcrumb'>
                                        <li className='breadcrumb-item'>
                                            <Link to='/reagent'>
                                                <i>
                                                    <FaArrowLeft />
                                                </i>
                                            </Link>
                                        </li>
                                        <li
                                            className='breadcrumb-item active'
                                            style={{ marginTop: "0.2em" }}
                                        >
                                            <i>Reagent Item List</i>
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <!-- Main content --> */}

                    <section className='content'>
                        <div className='container-fluid'>
                            <div className='row'>
                                <div className='col-9'>
                                    <div className='card'>
                                        <div className='card-header'>{medicineLists}</div>
                                        <div className='card-body bg-light' style={scroll}>
                                            <table id='' className='table'>
                                                <thead className='text-center bg-info sticky-top '>
                                                    <tr>
                                                        <th>No</th>
                                                        <th>Code</th>
                                                        <th>Name</th>
                                                        <th>Qty</th>
                                                        {/* <th>Reorder Qty</th> */}
                                                        <th>Price</th>

                                                        <th>To Unit</th>
                                                        <th>Purpose Types</th>
                                                        <th>Supplier</th>
                                                        <th>Device</th>
                                                        <th>Unit</th>
                                                        <th>Description</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>

                                                {unitLists[0] ? unitLists.map((unit, i) => (
                                                    <tbody className=''>
                                                        <tr>
                                                            <td>{++i}</td>
                                                            <td>{unit.code}</td>
                                                            <td>{unit.itemName}</td>
                                                            <td>
                                                                {unit.currentQuantity
                                                                    ? unit.currentQuantity
                                                                    : "0"}
                                                            </td>
                                                            {/* <td>{unit.reOrderQuantity}</td> */}
                                                            <td>{unit.purchasePrice}</td>
                                                            {/* <td>{unit.sellingPrice}</td> */}

                                                            <td>{unit.toUnit ? unit.toUnit : "0"}</td>
                                                            {/* <td></td> */}
                                                            <td>{unit.purposeType ? unit.purposeType : ""}</td>
                                                            <td>{unit?.relatedSupplier?.name}</td>
                                                            <td>{unit?.device}</td>
                                                            <td>{unit?.unit}</td>
                                                            <td>{unit.description}</td>
                                                            <td className='text-center'>
                                                                <button
                                                                    className='btn btn-sm btn-warning'
                                                                    onClick={(e) => handleUpdate(unit._id)}
                                                                >
                                                                    <FaRegEdit />
                                                                </button>
                                                                &nbsp;
                                                                <button
                                                                    className='btn btn-sm btn-danger'
                                                                    onClick={(e) => submit(unit._id)}
                                                                >
                                                                    <FaRegTrashAlt />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                )) : (
                                                    <div className='py-3 d-flex justify-content-center'>

                                                        {/* <img src={SearchIcon} width='70px' /> */}
                                                        <span className='text-md'>Loading . . .</span>

                                                    </div>
                                                )}
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                {showUpdate ? (
                                    <div className='col-md-3'>
                                        <div className='card px-3 py-3'>
                                            <h3 className='card-header mb-4 fw-5 text-secondary'>
                                                Update Item
                                            </h3>
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Code
                                                </label>
                                                <input
                                                    type='text'
                                                    class='form-control border-info'
                                                    name='codename'
                                                    id='code'
                                                    value={upCode}
                                                    onChange={(e) => setUpCode(e.target.value)}
                                                />
                                            </div>
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Name
                                                </label>
                                                <input
                                                    type='text'
                                                    class='form-control border-info'
                                                    name='balance'
                                                    id='name'
                                                    value={upName}
                                                    onChange={(e) => setUpName(e.target.value)}
                                                />
                                            </div>
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Current Quantity
                                                </label>
                                                <input
                                                    type='number'
                                                    class='form-control border-info'
                                                    name='balance'
                                                    id='cur_qty'
                                                    value={upCurQTY}
                                                    onChange={(e) => setUpCurQTY(e.target.value)}
                                                />
                                            </div>
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Reorder Quantity (Optional)
                                                </label>
                                                <input
                                                    type='number'
                                                    class='form-control border-info'
                                                    name='balance'
                                                    id='reorder'
                                                    value={upReOrder}
                                                    onChange={(e) => setUpReOrder(e.target.value)}
                                                />
                                            </div>
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Unit Convention (Optional)
                                                </label>
                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <input
                                                            type='number'
                                                            class='form-control border-info'
                                                            name='balance'
                                                            id='from'
                                                            value={upFrom}
                                                            onChange={(e) => setUpFrom(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <input
                                                            type='number'
                                                            class='form-control border-info'
                                                            name='balance'
                                                            id='to'
                                                            value={upTo}
                                                            onChange={(e) =>
                                                                handleUpdateUnitCalculation(e.target.value)
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Total Unit
                                                </label>
                                                <input
                                                    type='number'
                                                    class='form-control border-info'
                                                    name='balance'
                                                    id='total'
                                                    value={upTotal}
                                                />
                                            </div>

                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Purchase Price
                                                </label>
                                                <input
                                                    type='number'
                                                    class='form-control border-info'
                                                    name='balance'
                                                    id='purchase'
                                                    value={upPur}
                                                    onChange={(e) => setUpPur(e.target.value)}
                                                />
                                            </div>
                                            {/* <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Selling Price
                                                </label>
                                                <div className='row'>
                                                    <div className='col-md-12'>
                                                        <input
                                                            type='number'
                                                            class='form-control border-info'
                                                            name='balance'
                                                            id='sellprice'
                                                            value={upSell}
                                                            onChange={(e) => setUpSell(e.target.value)}
                                                        />
                                                    </div>
                                
                                                </div>
                                            </div> */}
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Purpose Type
                                                </label>
                                                <select
                                                    className='form-control'
                                                    onChange={(e) => setPurposeType(e.target.value)}
                                                >
                                                    <option value={purposeType} hidden>
                                                        {purposeType}
                                                    </option>

                                                    <option value='QC'>QC</option>
                                                    <option value='Test'>Test</option>
                                                    <option value='Calibration'>Calibration</option>
                                                    <option value='Maintainance'>Maintainance</option>
                                                </select>
                                            </div>
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Supplier
                                                </label>
                                                <select
                                                    className='form-control'
                                                    onChange={(e) => setSupplier(e.target.value)}
                                                >
                                                    <option hidden>{supplier ? supplier?.name : 'Select Supplier'}</option>
                                                    {supplierList.map((item) => (
                                                        <option key={item._id} value={item._id}>{item.name}</option>
                                                    ))}


                                                </select>
                                            </div>
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Device
                                                </label>
                                                <input
                                                    type='text'
                                                    class='form-control border-info'
                                                    name='balance'
                                                    id='purchase'
                                                    value={device}
                                                    //   ref={(el) => (this.name = el)}
                                                    onChange={(e) => setDevice(e.target.value)}
                                                />
                                            </div>
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Unit
                                                </label>
                                                <input
                                                    type='text'
                                                    class='form-control border-info'
                                                    name='balance'
                                                    id='purchase'
                                                    value={unit}
                                                    //   ref={(el) => (this.name = el)}
                                                    onChange={(e) => setUnit(e.target.value)}
                                                />
                                            </div>
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Expired Date
                                                </label>
                                                <input
                                                    type='date'
                                                    class='form-control border-info'
                                                    name='balance'
                                                    id='purchase'
                                                    value={expDate?.split('T')[0]}
                                                    //   ref={(el) => (this.name = el)}
                                                    onChange={(e) => setExpDate(e.target.value)}
                                                />
                                            </div>
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Description
                                                </label>
                                                <textarea
                                                    className='form-control'
                                                    id='description'
                                                    value={upDesc}
                                                    onChange={(e) => setUpDesc(e.target.value)}
                                                ></textarea>
                                            </div>
                                            <button
                                                className='btn btn-primary form-control text-center fw-5'
                                                onClick={UnitUpdate}
                                            >
                                                Update
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <div className='col-md-3'>
                                        <div className='card px-3 py-3'>
                                            <h3 className='card-header mb-4 fw-5 text-secondary'>
                                                Create Item
                                            </h3>
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Code
                                                </label>
                                                <input
                                                    type='text'
                                                    class='form-control border-info'
                                                    name='codename'
                                                    id='code'
                                                    //   ref={(el) => (this.name = el)}
                                                    onChange={(e) => setCode(e.target.value)}
                                                />
                                            </div>
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Name
                                                </label>
                                                <input
                                                    type='text'
                                                    class='form-control border-info'
                                                    name='balance'
                                                    id='name'
                                                    //   ref={(el) => (this.name = el)}
                                                    onChange={(e) => setName(e.target.value)}
                                                />
                                            </div>
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Current Quantity
                                                </label>
                                                <input
                                                    type='number'
                                                    class='form-control border-info'
                                                    name='balance'
                                                    id='cur_qty'
                                                    //   ref={(el) => (this.name = el)}
                                                    onChange={(e) => setCurrentQuantity(e.target.value)}
                                                />
                                            </div>
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Reorder Quantity (Optional)
                                                </label>
                                                <input
                                                    type='number'
                                                    class='form-control border-info'
                                                    name='balance'
                                                    id='reorder'
                                                    //   ref={(el) => (this.name = el)}
                                                    onChange={(e) => setReorder(e.target.value)}
                                                />
                                            </div>
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Unit Convention (Optional)
                                                </label>
                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <input
                                                            type='number'
                                                            class='form-control border-info'
                                                            name='balance'
                                                            id='from'
                                                            placeholder='Form Unit'
                                                            onChange={(e) => setFromUnit(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <input
                                                            type='number'
                                                            class='form-control border-info'
                                                            name='balance'
                                                            id='to'
                                                            placeholder='To Unit'
                                                            onChange={(e) =>
                                                                handleUnitCalculation(e.target.value)
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Total Unit
                                                </label>
                                                <input
                                                    type='number'
                                                    class='form-control border-info'
                                                    name='balance'
                                                    id='total'
                                                    disabled
                                                    //   ref={(el) => (this.name = el)}
                                                    value={totalUnit}
                                                />
                                            </div>

                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Purchase Price
                                                </label>
                                                <input
                                                    type='number'
                                                    class='form-control border-info'
                                                    name='balance'
                                                    id='purchase'
                                                    //   ref={(el) => (this.name = el)}
                                                    onChange={(e) => setPurchasePrice(e.target.value)}
                                                />
                                            </div>
                                            {/* <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Selling Price
                                                </label>
                                                <div className='row'>
                                                    <div className='col-md-12'>
                                                        <input
                                                            type='number'
                                                            class='form-control border-info'
                                                            name='balance'
                                                            id='sellprice'
                                                            onChange={(e) => setSellingPrice(e.target.value)}
                                                        />
                                                    </div>
                                   
                                                </div>
                                            </div> */}
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Purpose Type
                                                </label>
                                                <select
                                                    className='form-control'
                                                    onChange={(e) => setPurposeType(e.target.value)}
                                                >
                                                    <option hidden>Select Type</option>
                                                    <option value='QC'>QC</option>
                                                    <option value='Test'>Test</option>
                                                    <option value='Calibration'>Calibration</option>
                                                    <option value='Maintainance'>Maintainance</option>

                                                </select>
                                            </div>


                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Supplier
                                                </label>
                                                <select
                                                    className='form-control'
                                                    onChange={(e) => setSupplier(e.target.value)}
                                                >
                                                    <option hidden>Select Supplier</option>
                                                    {supplierList.map((item) => (
                                                        <option key={item._id} value={item._id}>{item.name}</option>
                                                    ))}


                                                </select>
                                            </div>
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Device
                                                </label>
                                                <input
                                                    type='text'
                                                    class='form-control border-info'
                                                    name='balance'
                                                    id='purchase'
                                                    //   ref={(el) => (this.name = el)}
                                                    onChange={(e) => setDevice(e.target.value)}
                                                />
                                            </div>
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Unit
                                                </label>
                                                <input
                                                    type='text'
                                                    class='form-control border-info'
                                                    name='balance'
                                                    id='purchase'
                                                    //   ref={(el) => (this.name = el)}
                                                    onChange={(e) => setUnit(e.target.value)}
                                                />
                                            </div>
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Expired Date
                                                </label>
                                                <input
                                                    type='date'
                                                    class='form-control border-info'
                                                    name='balance'
                                                    id='purchase'
                                                    //   ref={(el) => (this.name = el)}
                                                    onChange={(e) => setExpDate(e.target.value)}
                                                />
                                            </div>
                                            <div class='form-group'>
                                                <label for='name' className='text-secondary'>
                                                    Description
                                                </label>
                                                <textarea
                                                    className='form-control'
                                                    id='description'
                                                    //   ref={(el) => (this.description = el)}
                                                    onChange={(e) => setDescription(e.target.value)}
                                                ></textarea>
                                            </div>
                                            <button
                                                className='btn btn-primary form-control text-center fw-5'
                                                onClick={UnitCreate}
                                            >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        {/*<!-- /.container-fluid --> */}
                    </section>
                </div>
            </div>

            {/* <!-- /.content-wrapper --> */}
            <footer className='main-footer'>
                <strong>
                    Copyright &copy; 2017-2020{" "}
                    <a href='http://www.kwintechnologies.com'>K-win Technology</a>.
                </strong>
                All rights reserved.
            </footer>

            {/* <!-- Control Sidebar --> */}
            <aside classNameName='control-sidebar control-sidebar-dark'>
                {/* <!-- Control sidebar content goes here --> */}
            </aside>
            {/* <!-- /.control-sidebar --> */}

            {/* <!-- ./wrapper --> */}
        </div>
    );
}
export default Unit;
